import { productsURL } from 'helpers';
import { AppContext } from 'providers/AppContext';
import { useContext, useState } from 'react';
import { processIdSelector } from 'store/selectors';
import useSWR from 'swr';
import type { Products } from 'types';

export function useProducts() {
	const ctx = useContext(AppContext);
	const processId = processIdSelector(ctx.state.context);
	const url = productsURL(ctx.config.API, processId, true);
	const [selected, setSelected] = useState<string[]>([]);
	const { data } = useSWR<Products>(url);

	const handleSubmit = () => {
		if (selected.length) {
			const agreementProcessId = processIdSelector(ctx.state.context);
			const products = selected.map(productGroupId => ({ agreementProcessId, productGroupId }));
			const postURL = `${ctx.config.API.products}/${agreementProcessId}/InsertProductOrder`;
			const payload = { products, ssn: ctx.state.user.kennitala };
			const msg = ctx.t('submit_label', 'products');
			ctx.http.post(postURL, payload, msg).then(ctx.goToNextPage);
		}
	};

	return { ...ctx, data, handleSubmit, selected, setSelected };
}
